import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface BookingDetailAmountProps {
  /** Caption above the figure (e.g. "Amount paid", "Receipt"). */
  label: string;
  /** Formatted money, or null when no amount is known yet. */
  value: string | null;
  /** Small context line under the figure (payment model, amount source…). */
  caption?: ReactNode;
  className?: string;
}

/** Money-at-a-glance block for the booking detail hero (right-aligned on desktop). */
export function BookingDetailAmount({
  label,
  value,
  caption,
  className,
}: BookingDetailAmountProps) {
  return (
    <div
      className={cn(
        "flex min-w-0 flex-wrap items-baseline gap-x-2 sm:block sm:text-right",
        className,
      )}
    >
      <p className="text-xs font-medium text-surface-500">{label}</p>
      <p
        className={cn(
          "text-lg font-semibold tracking-tight tabular-nums sm:mt-0.5 sm:text-2xl",
          value ? "text-surface-900" : "text-surface-400",
        )}
      >
        {value ?? "—"}
      </p>
      {caption ? (
        <div className="text-xs text-surface-500 sm:mt-1">{caption}</div>
      ) : null}
    </div>
  );
}
